import React from 'react';
import PropTypes from 'prop-types';
// Material-UI
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
// Icons
import { X, CircleX } from 'tabler-icons-react';
// Context
import { useUsuarios } from './UsuariosContext';

export default function ModalBorrarUsuario({ open, onClose }) {
  const { selectionModel, delUser } = useUsuarios();

  const handleConfirm = () => {
    selectionModel.forEach(username => delUser(username));
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="usuarios-modal">
        <div className="usuarios-modal-header">
          <h2 className="usuarios-modal-title">Deshabilitar usuario</h2>
          <IconButton size="small" onClick={onClose}><X size={18} strokeWidth={2} /></IconButton>
        </div>

        <div className="usuarios-modal-body usuarios-modal-body--confirm">
          <CircleX size={56} color="#7D7F90" strokeWidth={1.5} />
          <p className="usuarios-confirm-text">
            ¿Está seguro que desea deshabilitar{' '}
            {selectionModel.length === 1
              ? 'el usuario seleccionado'
              : `los ${selectionModel.length} usuarios seleccionados`}?
          </p>
        </div>

        <div className="usuarios-modal-footer">
          <Button variant="outlined" className="usuarios-modal-cancel" onClick={onClose}>Cancelar</Button>
          <Button variant="contained" color="secondary" className="usuarios-modal-delete" onClick={handleConfirm}>
            Deshabilitar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

ModalBorrarUsuario.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
